<script setup lang="ts">
import FileTableRow from '@/modules/Workspaces/KnowledgeHub/Files/FileTableRow.vue'
import RowGrid from '@/modules/Workspaces/KnowledgeHub/Hubs/FileTable/RowGrid.vue'
import LoadingSkeleton from '@/sharedComponents/LoadingSkeleton.vue'

defineProps<{
  rows?: number
}>()
</script>

<template>
  <FileTableRow
    v-for="i in rows ?? 20"
    :key="i"
  >
    <template #grid>
      <RowGrid>
        <template #filename>
          <LoadingSkeleton
            :status="true"
            class="h-5 w-full max-w-52"
          />
        </template>
        <template #summary>
          <LoadingSkeleton
            :status="true"
            class="h-5 w-full max-w-44"
          />
        </template>
        <template #status>
          <LoadingSkeleton
            :status="true"
            class="h-5 w-full max-w-24"
          />
        </template>
        <template #createdAt>
          <LoadingSkeleton
            :status="true"
            class="h-5 w-full max-w-24"
          />
        </template>
      </RowGrid>
    </template>
  </FileTableRow>
</template>
